<template>
    <template v-if="videoLink && videoLink !== ''">
        <iframe
            v-show="showIFrame"
            class="dim__iframe"
            width="auto"
            height="400"
            :src="videoLink"
            style="border: none; flex-shrink: 0; margin-top: 0;"
            @load="handleIFrameLoaded"
        ></iframe>

        <div
            v-show="!showIFrame"
            class="dim__iframe"
            style="display: flex; align-items: center; flex-shrink: 0; margin-top: 0; justify-content: center; height: 370px;"
        >
            <img
                src="//cdn.shopify.com/s/files/1/0348/7101/7603/t/7/assets/loading.gif?v=2749976416133024973"
                width="54"
                height="54"
                alt="Loading"
            />
        </div>
    </template>
    <template v-else>
        <no-image-available width="auto" height="400" style="flex-shrink: 0" />
    </template>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { Diamond } from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import { useI18n } from "vue-i18n";
import NoImageAvailable from "@/components/NoImageAvailable.vue";

export default defineComponent({
    name: "DiamondImage",
    components: { NoImageAvailable },
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        }
    },
    setup(props) {
        const showIFrame = ref(false);

        const { videoLink } = useDiamondProperties(
            computed(() => props.diamond)
        );

        function handleIFrameLoaded() {
            showIFrame.value = true;
        }

        watch(videoLink, () => {
            showIFrame.value = false;
        });

        return { ...useI18n(), showIFrame, videoLink, handleIFrameLoaded };
    }
});
</script>

<style scoped></style>
